const colors = ['#2a9d8f', '#e79e4f', '#0077b6', '#e9c46a', '#ff9aa2', '#e5383b', '#73a942'];
const dark = '#212529';
const light = '#f8f9fa';

export { colors, dark, light };
